import { render, staticRenderFns } from "./XAxis.vue?vue&type=template&id=b1b4b72e&scoped=true&"
import script from "./XAxis.vue?vue&type=script&lang=js&"
export * from "./XAxis.vue?vue&type=script&lang=js&"
import style0 from "./XAxis.vue?vue&type=style&index=0&id=b1b4b72e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b4b72e",
  null
  
)

export default component.exports